import { Component, OnInit, EventEmitter } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Transition } from '@uirouter/angular';
import { DataService } from 'app/services/data.service';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { FrontEndService } from "../../services/front-end.service";

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
    feedback = "";
    message = "";
    feedback_error = false;
    errorMessage = '';
    fullScreenLoader = false;
    public  message_focus =  new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        private transition: Transition,
        public  dataService: DataService,
        public front_end_service: FrontEndService,
        private translate: TranslateService,
        private _location: Location,
    ) { }

    ngOnInit() {
    }

    onSubmit(feedback) {
        feedback["is_user_generated"] = 1;
        if (feedback["message"].trim() === "" || feedback["message"] === undefined) {
            this.message = "";
            this.message_focus.emit(true);
            this.feedback_error = true;
            this.errorMessage = 'enter_your_message.'
        } else {
            this.feedback_error = false;
            this.fullScreenLoader = true;
            this.user_management_service.feedback(feedback, (resp) => {
                if(resp.status === true) {
                    this.message = "";
                    this.front_end_service.addToast(
                        "Success",
                        "feedback_saved",
                        "success"
                    );
                }
                this.fullScreenLoader = false;
            });
        }
    }
}
